import LabsList from "../../components/labs/LabsList"

const LabsListPage = () => {
    return(
        <LabsList />
    )
}

export default LabsListPage